export default "__VITE_ASSET__FD5$ZELC__"